import React from "react";
import FooterLink, { KontentLink } from "./FooterLink";

// Kontent Schema
export type KontentLinkGroup = {
  elements: {
    title_link: { value: [KontentLink] };
    sub_links: { value: [KontentLink] };
  };
};

interface FooterLinkGroupProps {
  titleLink: { value: [KontentLink] };
  subLinks: { value: [KontentLink] };
}

const FooterLinkGroup = ({
  titleLink: {
    value: [titleLinkData],
  },
  subLinks: { value: subLinkData },
}: FooterLinkGroupProps) => {
  return (
    <ul className="flex flex-col gap-3 [&>li]:pl-3">
      <FooterLink
        internalPath={titleLinkData.elements.internal_path.value}
        externalUrl={titleLinkData.elements.external_url.value}
        target={titleLinkData.elements.open_in_new_window.value[0].codename}
        boldText
      >
        {titleLinkData.elements.text.value}
      </FooterLink>
      {subLinkData.map((link, idx) => (
        <li key={link.elements.text.value + idx}>
          <FooterLink
            internalPath={link.elements.internal_path.value}
            externalUrl={link.elements.external_url.value}
            target={link.elements.open_in_new_window.value[0].codename}
          >
            {link.elements.text.value}
          </FooterLink>
        </li>
      ))}
    </ul>
  );
};

export default FooterLinkGroup;
